import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Autocomplete,
  TextField,
  MenuItem,
  Select,
  CircularProgress,
} from "@material-ui/core";
import { getCostCenterData } from "../../actions";

function CostCenter({
  value,
  changeHandler,
  costCenter,
  index,
  disabled,
  bordered,
  row,
  setAlertMessage,
  setErrAlertMessage,
}) {
  const [costCenterList, setCostCenterList] = useState([]);
  const [loading, setLoading] = useState(false);
  const getCostCenter = async () => {
    getCostCenterData(costCenter, setLoading, setCostCenterList, () => {});
  };
  //   useEffect(() => {
  //     if (costCenterList.length > 0) {
  //       const finded = costCenterList.find(
  //         (x) => x.CostCenterCode === value
  //       );
  //       // value.Name = finded?.Name || "";
  //       value = finded?.CostCenterCode || "";

  //     }
  //   }, [costCenterList]);

  useEffect(() => {
    getCostCenter();
  }, []);
  // useEffect(() => {
  //   getCostCenter();
  // }, []);
  return (
    <Autocomplete
      id="selectedTaxCode"
      options={costCenterList}
      size="small"
      name="costCenter"
      disabled={disabled}
      // value={value || ""}
      // value={costCenterList.find((option) => option.CostCenterCode === value)|| {
      //   value: "",
      // }}
      value={
        costCenterList.find((option) => option.CostCenterCode === value) || ""
      }
      getOptionLabel={(option) =>
        (option !== "" &&
          `${`${option?.CostCenterCode} ${option?.Name ? "-" : ""}`}${
            option?.Name || ""
          }`) ||
        ""
      }
      loading={loading}
      variant="standard"
      onChange={(event, newValue) => {
        changeHandler(
          //   { target: { name: "costCenter",
          //   value: newValue?.CostCenterCode

          // } },
          {
            target: {
              name: "costCenter",
              value: newValue ? newValue.CostCenterCode : "", // Use newValue?.CostCenterCode if you're sure newValue is always defined
              ccName: newValue ? newValue.Name : "",
            },
          },
          index,
          row
        );
        if (!newValue?.IsActive && newValue != null) {
          setAlertMessage(true);
          setErrAlertMessage("This Cost center has been Blocked");
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          type="text"
          name=""
          onChange={(event) => {
            getCostCenterData(
              event.target.value,
              setLoading,
              setCostCenterList
            );
          }}
          variant={`${bordered ? "outlined" : "standard"}`}
          required
        />
      )}
    />
  );
}

export default CostCenter;
